export const chartColors=["#FFA49A","#FBD3AF","#A893FF","#FFD886","#93D8FF","#FF93E1"];
export const pieColors=["#FF93E1","#93D8FF","#FFD886","#A893FF","#FBD3AF","#FFA49A"]
export const fontFamily="Poppins"
